module.exports = __webpack_public_path__ + "img/banner1.cdbe0d14.png";